/* eslint-disable no-unused-vars */
// ProfileContext.js
import React, { createContext, useState, useContext, useCallback } from "react";
import { displayMPSProfile } from "../firebaseFunctions/displayMPSProfile/displayMPSProfile";
import { getAdditionalUserInfo } from "firebase/auth";

// Create context
const MPSEventRegistrationContext = createContext();

// Create the provider
export const MPSEventRegistrationProvider = ({ children }) => {
  const [MPSEventRegistrationData, setMPSEventRegistrationData] = useState({
    userId: "",
    eventId: "",
    fullName: "",
    businessEmail: "",
    businessName: "",
    companyLogoURL: "",
    businessType: "",
    businessPhoneNumber: "",
    smsPhoneNumber: "",
    businessDescription: "",
    businessWebsite: "",
    businessSocialProfiles: {},
    businessDocuments: [],
    datesApplyingFor: [],
    boothSize: "",
    additionalUserInfo: "",
  });

  // Function to update profile data
  // const updateMPSEventRegistration = (newData) => {
  //   const updatedData = { ...MPSEventRegistrationData, ...newData };
  //   setMPSEventRegistrationData(updatedData); // Set the state with the new data
  //   console.log("Updated Data", updatedData)
  //   return updatedData; // Return the updated data directly
  // };

  const updateMPSEventRegistration = (newData) => {
    if (Object.keys(newData).length > 0) { // Update only if newData is non-empty
      const updatedData = { ...MPSEventRegistrationData, ...newData };
      setMPSEventRegistrationData(updatedData);
      return updatedData;
    }
    return MPSEventRegistrationData;
  };

  // Function to submit profile data to Firebase
  const submitMPSEventRegistration = async () => {
    try {
      const socialProfilesList = Object.values(
        MPSEventRegistrationData.businessSocialProfiles
      );
      const request = {
        userId: MPSEventRegistrationData.userId,
        companyLogo: MPSEventRegistrationData.companyLogoURL,
        businessName: MPSEventRegistrationData.businessName,
        email: MPSEventRegistrationData.businessEmail,
        phoneNumber: MPSEventRegistrationData.businessPhoneNumber,
        description: MPSEventRegistrationData.businessDescription,
        socialMediaLinks: MPSEventRegistrationData.businessSocialProfiles, // Ensure it's an array
        // website: MPSBusinessProfileData.businessWebsite,
        website: MPSEventRegistrationData.businessWebsite,
        typeOfBusiness: MPSEventRegistrationData.businessType,
        documents: MPSEventRegistrationData.documents || [], // Ensure it's an array of objects
      };

      //   const response = await createMPSBusinessProfile(request);
      console.log("event registered successfully", MPSEventRegistrationData);
      return true;
      // Handle success or notify user
    } catch (error) {
      console.error("Error registering event:", error);
      return false;
      // Handle error or notify user
    }
  };
  // const getMPSEventRegistrationBusinessInfo = useCallback(async (MPSProfileID) => {
  //     try {
  //       const MPSBusinessProfileData = await displayMPSProfile(MPSProfileID);
  //       // const response = {};
  //       if (MPSBusinessProfileData && JSON.stringify(MPSBusinessProfileData) !== JSON.stringify(MPSEventRegistrationData)) {
  //         updateMPSEventRegistration({
  //           fullName: MPSBusinessProfileData?.fullName || "",
  //           businessEmail: MPSBusinessProfileData?.email || "",
  //           businessName: MPSBusinessProfileData?.businessName || "",
  //           companyLogoURL: MPSBusinessProfileData?.companyLogo || "",
  //           businessType: MPSBusinessProfileData?.typeOfBusiness || "",
  //           businessPhoneNumber: MPSBusinessProfileData?.phoneNumber || "",
  //           smsPhoneNumber: MPSBusinessProfileData?.smsPhoneNumber || "",
  //           businessDescription: MPSBusinessProfileData?.description || "",
  //           businessWebsite: MPSBusinessProfileData?.website || "",
  //           businessSocialProfiles: MPSBusinessProfileData?.socialMediaLinks || {},
  //           businessDocuments: MPSBusinessProfileData?.documents || [],
  //           datesApplyingFor:MPSBusinessProfileData?.datesApplyingFor || [],
  //           sizeBooth:MPSBusinessProfileData?.sizeBooth || "",
  //           additionalUserInfo: MPSBusinessProfileData?.additionalUserInfo || ""
  //         }); // Update only if data has changed
  //         console.log("MPSBusinessProfileData", MPSEventRegistrationData);
  //         return {success: true, data:MPSBusinessProfileData};
  //       }
  //     } catch (error) {
  //       console.error("Error getting event data by ID: ", error);
  //     }
  //   },
  //   [MPSEventRegistrationData]
  // ); // Memoize based on eventData

  const getMPSEventRegistrationBusinessInfo = useCallback(async (MPSProfileID) => {
    try {
      const MPSBusinessProfileData = await displayMPSProfile(MPSProfileID);
      if (MPSBusinessProfileData) {
        return { success: true, data: MPSBusinessProfileData };
      } else {
        return { success: false, data: null };
      }
    } catch (error) {
      console.error("Error getting event data by ID: ", error);
      return { success: false, data: null };
    }
  }, []);


  return (
    <MPSEventRegistrationContext.Provider
      value={{
        MPSEventRegistrationData,
        updateMPSEventRegistration,
        submitMPSEventRegistration,
        getMPSEventRegistrationBusinessInfo,
      }}
    >
      {children}
    </MPSEventRegistrationContext.Provider>
  );
};

// Custom hook to use the ProfileContext
export const useMPSEventRegistration = () => {
  return useContext(MPSEventRegistrationContext);
};
